import { FaBars } from 'react-icons/fa'

const FaBarsIcon = ({ onClick, title, size, style }) => {
  return (
    <FaBars
      title={title}
      size={size}
      style={style}
      onClick={onClick}
    />
  )
}

export default FaBarsIcon
